import useAppStore from '@/h5/stores/app'
import { customRequest, baseSecret } from '@/h5/api/activity'
import { randomNum, getTimestamp, getSignedData } from '@/packages/plugins/utils'
import { ref, onMounted, reactive, watch } from 'vue'
import Toast from '@/h5/components/toast'
import LGSdk from '@/packages/plugins/languageSDK/index'
import { getLanguage } from '@/packages/plugins/utils'
import ConfirmDialog from '@/h5/components/confirmDialog'
import golbalDataSourceSingle from '@/h5/hooks/useDataSource'

export const SURVEY_EVENTS = [
  {
    name: 'submitForm',
    label: '提交表单-问卷表单'
  },
  {
    name: 'submitFormBtn',
    label: '提交表单-问卷表单按钮',
    params: [
      {
        label: '选项下标',
        value: 'index'
      }
    ]
  }
]

export const SURVEY_DATA_SOURCE = [
  {
    label: '表单状态',
    keys: 'userSurvey.answerStatus',
    description: '状态值 1：未答卷 2：已答卷 3：问卷已关闭'
  },
  {
    label: '统计数据(表单按钮专用)',
    keys: 'userSurvey.countData[]'
  },
  {
    label: '统计数据-是否已选(表单按钮专用)',
    keys: 'userSurvey.isSelected[]'
  },
  {
    label: '问题ID(表单按钮专用)',
    keys: 'userSurvey.questionId'
  },
  {
    label: '问题名称(表单按钮专用)',
    keys: 'userSurvey.questionName'
  },
  {
    label: '选项列表(表单按钮专用)',
    keys: 'userSurvey.optionList'
  },
  {
    label: '选项列表-选项id(表单按钮专用)',
    keys: 'userSurvey.optionList[].optionId'
  },
  {
    label: '选项列表-选项名称(表单按钮专用)',
    keys: 'userSurvey.optionList[].optionTitle'
  },
  {
    label: '选项列表-选项图片(表单按钮专用)',
    keys: 'userSurvey.optionList[].optionUrl'
  },
  {
    label: '选项列表-选项统计数据(表单按钮专用)',
    keys: 'userSurvey.optionList[].statisticsCount'
  },
  {
    label: '选项列表-选项是否已选(表单按钮专用)',
    keys: 'userSurvey.optionList[].isSelected'
  }
]

export const API = {
  /**
   * 获取活动配置
   * @param {*} id
   * @returns
   */
  getActivityConfig: async (id, uid) => {
    const params = {
      id,
      sign: '',
      appId: 1004,
      random: randomNum(6),
      timestamp: getTimestamp()
    }
    const language = getLanguage('api')
    let headers = {
      language,
      uid
    }
    params.sign = getSignedData(params, baseSecret)
    return customRequest(null, '/v1/survey/detail', 'get', headers, params)
  },
  /**
   * 获取活动配置-问卷表单按钮
   * @param {*} id
   * @returns
   *  */
  getActivityConfigBtn: async (id, uid) => {
    const params = {
      id,
      sign: '',
      appId: 1004,
      random: randomNum(6),
      timestamp: getTimestamp()
    }
    const language = getLanguage('api')
    let headers = {
      language,
      uid
    }
    params.sign = getSignedData(params, baseSecret)
    return customRequest(null, '/v1/survey/template/detail', 'get', headers, params)
  },
  /**
   * 提交问卷
   * @param {*} id
   * @param {*} answerId
   * @param {*} version
   * @param {*} endTime
   * @param {*} answerList
   * @returns
   */
  submit: async (params) => {
    const language = getLanguage('api')
    const appStore = useAppStore ? useAppStore() : null
    const token = appStore?.unityToken
    const headers = golbalDataSourceSingle?.getDataSourceHeaders([
      {
        key: 'uid',
        value: ''
      },
      {
        key: 'pf',
        value: ''
      }
    ])
    headers.language = language
    headers.token = token
    const reqParams = {
      sign: '',
      appId: 1004,
      random: randomNum(6),
      timestamp: getTimestamp(),
      ...params
    }
    reqParams.sign = getSignedData(reqParams, baseSecret)
    return customRequest(null, '/v1/survey/submit', 'post', headers, reqParams)
  },
  /**
   * 上报答卷时间
   * @param {*} id
   * @param {*} answerId
   * @param {*} startTime
   * @returns
   */
  reportTime: async (params) => {
    const language = getLanguage('api')
    const appStore = useAppStore ? useAppStore() : null
    const token = appStore?.unityToken
    const headers = golbalDataSourceSingle?.getDataSourceHeaders([
      {
        key: 'uid',
        value: ''
      },
      {
        key: 'pf',
        value: ''
      }
    ])
    headers.language = language
    headers.token = token
    const reqParams = {
      sign: '',
      appId: 1004,
      random: randomNum(6),
      timestamp: getTimestamp(),
      ...params
    }
    reqParams.sign = getSignedData(reqParams, baseSecret)
    return customRequest(null, '/v1/survey/report', 'post', headers, reqParams)
  },
  /**
   * 数量统计
   * @param {*} id
   * @returns
   *  */
  getStatistics: async (id) => {
    const appStore = useAppStore ? useAppStore() : null
    const token = appStore?.unityToken
    const language = getLanguage('api')
    const headers = golbalDataSourceSingle?.getDataSourceHeaders([
      {
        key: 'uid',
        value: ''
      },
      {
        key: 'pf',
        value: ''
      }
    ])
    headers.language = language
    headers.token = token

    const reqParams = {
      id,
      timestamp: getTimestamp(),
      appId: 1004,
      random: randomNum(6),
      sign: ''
    }
    reqParams.sign = getSignedData(reqParams, baseSecret)
    return customRequest(null, '/v1/survey/statistics', 'get', headers, reqParams)
  }
}

export const useSurvey = (props, initSurveyFunc, setQuestionsFunc, setAutoRecognitionFunc, dealWithFormDataFunc, setAnswerStatusFunc) => {
  const componentRef = ref(null)
  const surveyRef = ref(null)
  const appStore = useAppStore ? useAppStore() : null

  // 属性
  const state = reactive({
    // 语言
    language: 'en',
    // 组件uuid
    uuid: '',
    // 配置
    surveyCfg: {},
    // 答卷id
    answerId: null,
    // 上报时间问卷状态
    surveyStatus: 1,
    // 提交loading
    loading: false,
    // 数据源
    dataSource: {
      userSurvey: {}
    }
  })

  const initSurvey = () => {
    try {
      if (state.surveyCfg?.id) {
        // 初始化
        initSurveyFunc && initSurveyFunc(state.surveyCfg)
        if (props.requestStatistic) {
          getStatisticsData()
        }
        // 问卷是否可编辑提示
        if (state.surveyCfg?.answerStatus === 3) {
          Toast && Toast({ message: LGSdk.t(props.requestStatistic ? 'survey.activityClosed' : 'survey.10703'), duration: 1500 })
          console.log('问卷已关闭')
          return
        }
        setQuestions()
        // 自动识别
        autoInput()
      }
    } catch (e) {
      console.error(e)
      Toast && Toast({ message: LGSdk.t('survey.initFail'), duration: 1500 })
    }
  }

  const setQuestions = () => {
    if (props.questions?.length === 0) {
      return
    }
    setQuestionsFunc && setQuestionsFunc(state.surveyCfg, state.language)
  }

  const autoInput = async () => {
    if (!appStore || !setAutoRecognitionFunc) {
      return
    }
    // 找到所有要自动识别的数据
    const dataMap = new Map()
    state.surveyCfg?.questionList?.forEach((question) => {
      if (question.autoRecognition) {
        let content = [4, 6].includes(question.type) ? [] : ''
        const uid = appStore?.uid || ''
        const nickname = appStore?.nickName || ''
        let sex = appStore?.pageDataSource['data-source_userConstant']?.sex || ''
        if (sex && [1, 2].includes(question.type)) {
          sex = LGSdk.t(sex === 1 ? 'sex.male' : 'sex.female')
        }
        const countryCode = state.surveyCfg.countryCode || ''
        switch (question.autoRecognition) {
          case 'uid':
            content = typeof content !== 'string' ? (uid ? [uid] : []) : uid
            break
          case 'nickname':
            content = typeof content !== 'string' ? (nickname ? [nickname] : []) : nickname
            break
          case 'sex':
            content = typeof content !== 'string' ? (sex ? [sex] : []) : sex
            break
          case 'countryCode':
            content = typeof content !== 'string' ? (countryCode ? [countryCode] : []) : countryCode
            break
          default:
            break
        }
        dataMap.set(question.questionId, content)
      }
    })
    // 调用方法回填
    setAutoRecognitionFunc(dataMap)
  }

  const reportTime = (time, tryCount = 0) => {
    return new Promise((resolve, reject) => {
      if (state.surveyCfg.answerStatus !== 1) {
        return reject(new Error('Invalid answer status'))
      }
      const params = {
        id: state.surveyCfg.id,
        version: state.surveyCfg.version,
        startTime: time
      }
      console.log('report-time', params)
      // 上报时间
      API.reportTime(params)
        .then((res) => {
          // 问卷已关闭无法获取answerId
          state.surveyStatus = res.data.surveyStatus
          if (res.data.answerId) {
            state.answerId = res.data.answerId
            console.log('上报成功', res.data)
            resolve()
          } else {
            state.surveyCfg.answerStatus = 3
            reject()
          }
        })
        .catch((e) => {
          console.error(e)
          if (!['9004', '9005', '10016'].includes(e?.code)) {
            console.error(e?.code)
            if (tryCount === 3) {
              // 最大次数请求失败
              Toast && Toast({ message: LGSdk.t(`survey.networkError`), duration: 1500 })
              reject(new Error('Max retry count reached'))
              return
            }
            tryCount++
            setTimeout(() => resolve(reportTime(time, tryCount)), 1000)
          } else {
            state.surveyCfg.answerStatus = 3
            state.surveyStatus = 3
            reject()
          }
        })
    }).catch((e) => {
      state.loading = false
      console.log(e)
    })
  }

  const submitForm = async () => {
    if (state.loading) {
      return
    }
    if (state.surveyStatus !== 1) {
      // 问卷已关闭
      Toast && Toast({ message: LGSdk.t(`survey.10703`), duration: 1500 })
      return
    }
    if (state.surveyCfg.answerStatus !== 1) {
      return
    }
    state.loading = true
    // 校验
    const { isValid, customMessage } = await surveyRef.value.validate()
    if (!isValid) {
      Toast && Toast({ message: customMessage || LGSdk.t('survey.unfinishedContent'), duration: 1500 })
      state.loading = false
      return
    }
    // 二次确认
    const res =
      ConfirmDialog &&
      (await ConfirmDialog({
        title: LGSdk.t('public.tips'),
        message: LGSdk.t('survey.submitConfirmInfo'),
        confirmText: LGSdk.t('public.confirm'),
        cancelText: LGSdk.t('public.cancel')
      }))
    if (res?.type === 'cancel') {
      state.loading = false
      return false
    }
    // 记录提交时间
    const endTime = Date.now()
    // 判断是否上报过
    if (!state.answerId) {
      try {
        await reportTime(endTime)
      } catch (e) {
        // 问卷已关闭
        Toast && Toast({ message: LGSdk.t(`survey.10703`), duration: 1500 })
        return
      }
    }
    // 请求后端
    const answerList = dealWithFormDataFunc(state.surveyCfg.questionList)
    const submitParams = {
      id: state.surveyCfg.id,
      version: state.surveyCfg.version,
      answerId: state.answerId,
      endTime,
      answerList
    }
    console.log('submitParams', submitParams)
    API.submit(submitParams)
      .then(() => {
        // 成功则跳转
        setAnswerStatusFunc(2)
        state.surveyCfg.answerStatus = 2
        state.dataSource.userSurvey.answerStatus = state.surveyCfg.answerStatus
        appStore.setNodeAttribute(props.dialogUUID, 'hiden', false)
        state.loading = false
      })
      .catch((e) => {
        // 表单关闭提示
        console.error(e)
        state.loading = false
        if (e?.code) {
          Toast && Toast({ message: LGSdk.t(`survey.${e.code}`), duration: 1500 })
          if (e.code === '10704' || e.code === '10703') {
            state.surveyCfg.answerStatus = e.code === '10704' ? 2 : 3
            state.dataSource.userSurvey.answerStatus = state.surveyCfg.answerStatus
            setAnswerStatusFunc(state.surveyCfg.answerStatus)
          }
        }
      })
      .finally(() => {
        appStore?.setPageDataSource(state.uuid, state.dataSource || null)
      })
  }

  const submitFormBtn = async (params) => {
    if (state.loading) {
      return
    }
    if (state.surveyStatus !== 1) {
      // 问卷已关闭
      Toast && Toast({ message: LGSdk.t(`survey.10703`), duration: 1500 })
      return
    }
    state.loading = true
    const index = Number(params.index)
    if (state.surveyCfg.answerStatus !== 1) {
      if (state.surveyCfg.answerStatus === 2) {
        Toast && Toast({ message: LGSdk.t('survey.10704'), duration: 1500 })
      } else if (state.surveyCfg.answerStatus === 3) {
        Toast && Toast({ message: LGSdk.t('survey.activityClosed'), duration: 1500 })
      }
      state.loading = false
      return
    }
    try {
      await reportTime(Date.now())
    } catch (e) {
      // 问卷已关闭
      Toast && Toast({ message: LGSdk.t(`survey.10703`), duration: 1500 })
      return
    }
    // 记录提交时间
    const endTime = Date.now()
    // 具体问题的具体选项
    const option = state.surveyCfg.questionList[0].optionList[index]
    // 请求后端
    const answerList = [
      {
        questionId: state.surveyCfg.questionList[0].questionId,
        optionList: [
          {
            type: 3, // 固定为单选
            optionId: option.optionId,
            textAnswer: ''
          }
        ]
      }
    ]
    const submitParams = {
      id: state.surveyCfg.id,
      version: state.surveyCfg.version,
      answerId: state.answerId,
      endTime,
      answerList
    }
    try {
      const res = await API.submit(submitParams)
      if (res.status === 1) {
        // 成功则跳转
        console.log('成功提交')
        appStore.setNodeAttribute(props.dialogUUID, 'hiden', false)
        state.surveyCfg.answerStatus = 2
        state.dataSource.userSurvey.answerStatus = state.surveyCfg.answerStatus
        state.loading = false
        getStatisticsData(true)
      } else {
        // 失败，提示错误
        state.loading = false
        Toast && Toast({ message: LGSdk.t('survey.submitFail'), duration: 1500 })
      }
    } catch (e) {
      console.error(e)
      state.loading = false
      if (e?.code === '10704') {
        state.surveyCfg.answerStatus = 2
        Toast && Toast({ message: LGSdk.t('survey.10704'), duration: 1500 })
      } else if (e?.code === '10703') {
        state.surveyCfg.answerStatus = 3
        Toast && Toast({ message: LGSdk.t('survey.activityClosed'), duration: 1500 })
      } else {
        Toast && Toast({ message: LGSdk.t(`survey.${e?.code}`), duration: 1500 })
      }
      state.dataSource.userSurvey.answerStatus = state.surveyCfg.answerStatus
    } finally {
      appStore?.setPageDataSource(state.uuid, state.dataSource || null)
    }
  }

  const getStatisticsData = async (isRefresh = false) => {
    if (!state.surveyCfg?.id) {
      return
    }
    if (isRefresh) {
      const res = await API.getActivityConfigBtn(props.activityId, appStore.uid)
      state.surveyCfg = res?.data || {}
    }
    API.getStatistics(state.surveyCfg.id)
      .then((res) => {
        if (res.data) {
          const countData = []
          const isSelected = []
          state.surveyCfg?.questionList[0].optionList?.forEach((item) => {
            const isExist = res.data.questionList[0]?.answerList.find((aItem) => aItem.optionId === item.optionId)
            const count = isExist ? isExist.answerTotal : 0
            const selected = item.selected ? true : false
            item.statisticsCount = count
            item.isSelected = selected
            countData.push(count)
            isSelected.push(selected)
          })
          state.dataSource.userSurvey.countData = countData
          state.dataSource.userSurvey.isSelected = isSelected
          state.dataSource.userSurvey.questionId = state.surveyCfg?.questionList[0]?.questionId || ''
          state.dataSource.userSurvey.questionName = state.surveyCfg?.questionList[0]?.questionTitle || ''
          state.dataSource.userSurvey.optionList = state.surveyCfg?.questionList[0]?.optionList || []
          // 排序，根据statisticsCount的值进行排序
          state.dataSource.userSurvey.optionList.sort((a, b) => b.statisticsCount - a.statisticsCount)
          appStore?.setPageDataSource(state.uuid, state.dataSource || null)
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  // 页面初始化
  const init = async () => {
    const api = props.requestStatistic ? API.getActivityConfigBtn : API.getActivityConfig
    const res = await api(props.activityId, appStore.uid)
    state.surveyCfg = res?.data || {}
    if (!state.surveyCfg?.id) {
      Toast && Toast({ message: LGSdk.t('survey.initFail'), duration: 1500 })
    }
    // 更新数据源
    if (state.surveyCfg?.answerStatus) {
      state.dataSource.userSurvey.answerStatus = state.surveyCfg.answerStatus
      appStore?.setPageDataSource(state.uuid, state.dataSource || null)
    }
    initSurvey()
  }

  // 编辑器初始化
  const getConfig = async () => {
    if (props.activityId) {
      const api = props.requestStatistic ? API.getActivityConfigBtn : API.getActivityConfig
      const res = await api(props.activityId, -1)
      state.surveyCfg = res?.data || {}
      initSurvey()
      return res.data || null
    }
  }

  watch(
    () => props,
    () => initSurvey(),
    {
      immediate: true,
      deep: true
    }
  )

  onMounted(() => {
    if (componentRef.value) {
      state.language = componentRef.value.getAttribute('language') || 'en'
      state.uuid = componentRef.value.getAttribute('id') || ''
    }
    if (import.meta.env.VITE_APP_TAG !== 'H5') {
      // 非H5环境，直接获取配置
      getConfig()
    }
  })

  watch(
    () => appStore?.uid,
    (val) => {
      if (import.meta.env.VITE_APP_TAG === 'H5' && val) {
        init()
      }
    },
    { immediate: true }
  )

  return {
    componentRef,
    surveyRef,
    getConfig,
    reportTime,
    submitForm,
    submitFormBtn
  }
}
